
const BetaIndicator = ({ className = '' }) => {
  return (
    <div
      className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-semibold text-white bg-gradient-to-r from-orange-500 to-amber-500 dark:from-orange-600 dark:to-amber-600 shadow-sm hover:shadow-md transition-all duration-200 hover:scale-105 flex-shrink-0 ${className}`}
      title="This application is currently in beta testing"
    >
      {/* Beaker/Test tube icon */}
      <svg
        className="w-3 h-3"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          d="M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C1.586 14.001 2.512 16 4.414 16h11.172c1.902 0 2.828-1.999 1.707-3.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.993 1.993 0 00-.135-.041L9 8.172z"
          clipRule="evenodd"
        />
      </svg>
      <span>BETA</span>
    </div>
  );
};

export default BetaIndicator;